import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
 
import { DataService } from './data.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private _DataService: DataService) {}
    
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // console.log(" request data ",request)
            return next.handle(request).pipe(catchError(err => {
        //   console.log("err -->>", err);
            if ([401, 403].includes(err.status)) {
                console.log("need to call logout", request);
                // auto logout if 401 or 403 response returned from api
                // this._DataService.logout();
            }

            const error = err.error?.message || err.statusText;
            console.error(err);
            return throwError(() => error);
        }))
    }
}